(function () {
  'use strict';

  if (window.JdgmCarouselGrid && window.JdgmCarouselGrid.bootstrapped) return;

  var GRID_CLASS = 'jdgm-carousel--jdgm-grid';
  var WRAP_CLASS = 'apps-section-wrap--jdgm-grid';
  var SECTION_CLASS = 'shopify-section--jdgm-grid';
  var INIT_ATTR = 'data-jdgm-grid-init';
  var OBSERVER_DEBOUNCE_MS = 300;
  var observerTimer = null;
  var MAX_ITEMS = 8;
  var QUOTE_INDICES = [1, 7];
  var QUOTE_VARIANTS = ['jdgm-grid-item--quote-blue', 'jdgm-grid-item--quote-peach'];

  var instances = [];
  var reviewDataByItem = new WeakMap();
  var activeReviewOpener = null;
  var reviewModal = null;
  var ITEM_INLINE_RESET = ['width', 'max-width', 'min-width', 'height', 'transform', 'left', 'right', 'margin', 'flex', 'font-size'];

  function clearInline(el, props) {
    if (!el || !el.style) return;
    for (var i = 0; i < props.length; i++) el.style.removeProperty(props[i]);
  }

  function getCarouselItems(container) {
    if (!container) return [];

    if (container.querySelector('.jdgm-marquee-track')) {
      var activeGroup = container.querySelector('.jdgm-marquee-group:not(.jdgm-marquee-group--clone)');
      if (!activeGroup) return [];
      return activeGroup.querySelectorAll('.jdgm-carousel-item:not(.jdgm-carousel-item--marquee-clone)');
    }

    var wrapper = container.querySelector('.jdgm-carousel__item-wrapper');
    var scope = wrapper || container;
    return scope.querySelectorAll('.jdgm-carousel-item:not(.jdgm-carousel-item--marquee-clone)');
  }

  function normalizeCarouselItem(item) {
    clearInline(item, ITEM_INLINE_RESET);
    item.classList.remove('jdgm-carousel-item--marquee-clone', 'jdgm-grid-item--photo', 'jdgm-grid-item--quote');
    QUOTE_VARIANTS.forEach(function (cls) {
      item.classList.remove(cls);
    });
  }

  function markSectionGrid(carousel) {
    var wrap = carousel.closest('.apps-section-wrap--full') || carousel.closest('.apps-section-wrap');
    if (wrap) {
      wrap.classList.remove('apps-section-wrap--jdgm-marquee');
      wrap.classList.add(WRAP_CLASS);
    }

    var section = carousel.closest('.shopify-section');
    if (section) {
      section.classList.remove('shopify-section--jdgm-marquee');
      section.classList.add(SECTION_CLASS);
    }

    var appShell = carousel.closest('.shopify-app-block');
    if (appShell) {
      appShell.querySelectorAll('div').forEach(function (el) {
        if (el.contains(carousel)) {
          clearInline(el, [
            'max-width', 'width', 'margin', 'margin-left', 'margin-right',
            'padding-left', 'padding-right', 'padding-top', 'padding-bottom', 'padding'
          ]);
        }
      });
    }

    var wrapper = carousel.closest('.jdgm-carousel-wrapper');
    if (wrapper) {
      clearInline(wrapper, [
        'max-width', 'width', 'margin-left', 'margin-right',
        'padding', 'padding-top', 'padding-bottom'
      ]);
    }

    var container = carousel.querySelector('.jdgm-carousel__item-container');
    if (container) {
      clearInline(container, [
        'max-width', 'width', 'margin-left', 'margin-right',
        'padding-left', 'padding-right'
      ]);
    }
  }

  function destroyGrid(instance) {
    if (!instance || !instance.carousel) return;

    var carousel = instance.carousel;
    var container = instance.container;
    var wrap = carousel.closest('.apps-section-wrap--full') || carousel.closest('.apps-section-wrap');

    if (container && instance.items && instance.items.length) {
      container.innerHTML = '';
      instance.items.forEach(function (item) {
        normalizeCarouselItem(item);
        container.appendChild(item);
      });
    }

    carousel.classList.remove(GRID_CLASS, 'jdgm-carousel--jdgm-marquee', 'jdgm-carousel--jdgm-marquee-paused');
    carousel.removeAttribute(INIT_ATTR);
    carousel.removeAttribute('data-jdgm-marquee-init');
    if (wrap) wrap.classList.remove(WRAP_CLASS);
    var section = carousel.closest('.shopify-section');
    if (section) section.classList.remove(SECTION_CLASS);
  }

  function titleMarginBottom() {
    return window.matchMedia('(max-width: 749px)').matches ? '16px' : '2rem';
  }

  function applyHeaderSpacing(carousel) {
    var titleBlock = carousel.closest('.jdgm-carousel-wrapper');
    if (!titleBlock) titleBlock = carousel;
    titleBlock = titleBlock.querySelector('.jdgm-carousel-title-and-link') || titleBlock;

    var container = carousel.querySelector('.jdgm-carousel__item-container');

    if (titleBlock && titleBlock.classList && titleBlock.classList.contains('jdgm-carousel-title-and-link')) {
      titleBlock.style.setProperty('margin-bottom', titleMarginBottom(), 'important');
    } else if (carousel.closest('.jdgm-carousel-wrapper')) {
      var titleLink = carousel.closest('.jdgm-carousel-wrapper').querySelector('.jdgm-carousel-title-and-link');
      if (titleLink) titleLink.style.setProperty('margin-bottom', titleMarginBottom(), 'important');
    }

    if (container) {
      container.style.removeProperty('margin-top');
      container.style.setProperty('margin-top', '0', 'important');
    }
  }

  function textFrom(item, selector) {
    var element = item.querySelector(selector);
    return element ? element.textContent.trim() : '';
  }

  function scoreFromRating(rating) {
    if (!rating) return 0;

    var dataScore = Number(rating.getAttribute('data-score'));
    if (dataScore) return dataScore;

    var labelMatch = (rating.getAttribute('aria-label') || '').match(/[\d.]+/);
    if (labelMatch) return Number(labelMatch[0]) || 0;

    return rating.querySelectorAll('.jdgm-star.jdgm--on').length;
  }

  function captureReviewData(item) {
    if (reviewDataByItem.has(item)) return reviewDataByItem.get(item);

    var image = item.querySelector('.jdgm-carousel-item__product-image');
    var rating = item.querySelector('.jdgm-carousel-item__review-rating');
    var data = {
      imageSrc: image ? image.currentSrc || image.src || image.getAttribute('data-src') || '' : '',
      imageAlt: image ? image.alt || '' : '',
      score: scoreFromRating(rating),
      reviewer: textFrom(item, '.jdgm-carousel-item__reviewer-name'),
      title: textFrom(item, '.jdgm-carousel-item__review-title'),
      body: textFrom(item, '.jdgm-carousel-item__review-body'),
      product: textFrom(item, '.jdgm-carousel-item__product-title'),
      timestamp: textFrom(item, '.jdgm-carousel-item__timestamp')
    };

    reviewDataByItem.set(item, data);
    return data;
  }

  function setModalText(modal, selector, value) {
    var element = modal.querySelector(selector);
    if (!element) return;
    element.textContent = value || '';
    element.hidden = !value;
  }

  function populateReviewModal(modal, data) {
    var image = modal.querySelector('.jdgm-review-modal__image');
    if (image) {
      if (data.imageSrc) {
        image.src = data.imageSrc;
        image.alt = data.imageAlt || 'Customer review image';
        image.hidden = false;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
      }
    }

    var score = Math.max(0, Math.min(5, Math.round(data.score || 0)));
    var rating = modal.querySelector('.jdgm-review-modal__rating');
    if (rating) {
      rating.textContent = score ? '\u2605'.repeat(score) + '\u2606'.repeat(5 - score) : '';
      rating.hidden = !score;
      if (score) rating.setAttribute('aria-label', score + ' out of 5 stars');
      else rating.removeAttribute('aria-label');
    }

    var body = data.body || data.title;
    var title = data.title && data.title !== body ? data.title : 'Customer review';
    var meta = [data.product, data.timestamp].filter(Boolean).join(' \u00b7 ');

    setModalText(modal, '.jdgm-review-modal__reviewer', data.reviewer);
    setModalText(modal, '.jdgm-review-modal__title', title);
    setModalText(modal, '.jdgm-review-modal__body', body);
    setModalText(modal, '.jdgm-review-modal__meta', meta);
  }

  function ensureReviewModal() {
    if (reviewModal && reviewModal.isConnected) return reviewModal;

    reviewModal = document.createElement('dialog');
    reviewModal.className = 'jdgm-review-modal';
    reviewModal.setAttribute('aria-labelledby', 'JdgmReviewModalTitle');
    reviewModal.innerHTML =
      '<div class="jdgm-review-modal__panel">' +
        '<button type="button" class="jdgm-review-modal__close" aria-label="Close full review">&times;</button>' +
        '<img class="jdgm-review-modal__image" alt="">' +
        '<div class="jdgm-review-modal__content">' +
          '<div class="jdgm-review-modal__rating"></div>' +
          '<p class="jdgm-review-modal__reviewer"></p>' +
          '<h2 id="JdgmReviewModalTitle" class="jdgm-review-modal__title"></h2>' +
          '<p class="jdgm-review-modal__body"></p>' +
          '<p class="jdgm-review-modal__meta"></p>' +
        '</div>' +
      '</div>';

    document.body.appendChild(reviewModal);

    reviewModal.querySelector('.jdgm-review-modal__close').addEventListener('click', function () {
      reviewModal.close();
    });

    reviewModal.addEventListener('click', function (event) {
      if (event.target === reviewModal) reviewModal.close();
    });

    reviewModal.addEventListener('close', function () {
      if (activeReviewOpener && activeReviewOpener.isConnected) activeReviewOpener.focus();
      activeReviewOpener = null;
    });

    var modalImage = reviewModal.querySelector('.jdgm-review-modal__image');
    modalImage.addEventListener('error', function () {
      modalImage.hidden = true;
    });

    return reviewModal;
  }

  function openReviewModal(item) {
    var data = reviewDataByItem.get(item) || captureReviewData(item);
    var modal = ensureReviewModal();
    activeReviewOpener = item;
    populateReviewModal(modal, data);
    if (!modal.open) modal.showModal();
  }

  function markReviewCard(item) {
    var data = captureReviewData(item);
    item.setAttribute('role', 'button');
    item.setAttribute('tabindex', '0');
    item.setAttribute('aria-haspopup', 'dialog');
    item.setAttribute('aria-label', 'Read full review' + (data.reviewer ? ' by ' + data.reviewer : ''));
  }

  function bindReviewCardInteractions(carousel) {
    if (carousel.getAttribute('data-jdgm-review-dialog-bound') === 'true') return;
    carousel.setAttribute('data-jdgm-review-dialog-bound', 'true');

    carousel.addEventListener('click', function (event) {
      var item = event.target.closest('.jdgm-carousel-item');
      if (!item || !carousel.contains(item) || item.classList.contains('jdgm-carousel-item--marquee-clone')) return;
      event.preventDefault();
      openReviewModal(item);
    });

    carousel.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var item = event.target.closest('.jdgm-carousel-item');
      if (!item || !carousel.contains(item) || item.classList.contains('jdgm-carousel-item--marquee-clone')) return;
      event.preventDefault();
      openReviewModal(item);
    });
  }

  function prepareQuoteItem(item, variantClass) {
    item.classList.add('jdgm-grid-item--quote', variantClass);

    var imageWrapper = item.querySelector('.jdgm-carousel-item__image-wrapper');
    if (imageWrapper) imageWrapper.remove();

    var productWrapper = item.querySelector('.jdgm-carousel-item__product-wrapper');
    if (productWrapper) productWrapper.remove();

    var titleEl = item.querySelector('.jdgm-carousel-item__review-title');
    var bodyEl = item.querySelector('.jdgm-carousel-item__review-body');
    var titleText = titleEl ? titleEl.textContent.trim() : '';
    var bodyText = bodyEl ? bodyEl.textContent.trim() : '';
    var quoteText = bodyText || titleText;

    if (titleEl && quoteText) {
      titleEl.textContent = quoteText;
      titleEl.classList.remove('jdgm-ellipsis', 'jdgm-carousel-item__review-body-only');
    }

    if (bodyEl) bodyEl.remove();

    item.querySelectorAll('.jdgm-carousel-item__review-rating').forEach(function (rating) {
      rating.remove();
    });

    var reviewerWrapper = item.querySelector('.jdgm-carousel-item__reviewer-wrapper');
    if (reviewerWrapper) reviewerWrapper.remove();
  }

  function buildGrid(carousel) {
    if (carousel.getAttribute(INIT_ATTR) === 'true') return null;

    var container = carousel.querySelector('.jdgm-carousel__item-container');
    if (!container) return null;

    var allItems = Array.prototype.slice.call(getCarouselItems(container));
    if (!allItems.length) return null;

    carousel.setAttribute(INIT_ATTR, 'true');
    carousel.classList.remove('jdgm-carousel--jdgm-marquee', 'jdgm-carousel--jdgm-marquee-paused');
    carousel.classList.add(GRID_CLASS);
    carousel.removeAttribute('data-jdgm-marquee-init');
    markSectionGrid(carousel);
    applyHeaderSpacing(carousel);

    clearInline(container, [
      'transform', 'transition', 'left', 'right', 'width', 'height',
      'margin-left', 'margin-right', 'padding-left', 'padding-right'
    ]);

    var visibleItems = allItems.slice(0, MAX_ITEMS);
    var grid = document.createElement('div');
    grid.className = 'jdgm-grid';

    visibleItems.forEach(function (item, index) {
      normalizeCarouselItem(item);
      markReviewCard(item);

      if (QUOTE_INDICES.indexOf(index) !== -1) {
        var quoteVariant = QUOTE_VARIANTS[QUOTE_INDICES.indexOf(index)] || QUOTE_VARIANTS[0];
        prepareQuoteItem(item, quoteVariant);
      } else {
        item.classList.add('jdgm-grid-item--photo');
      }

      grid.appendChild(item);
    });

    container.innerHTML = '';
    container.appendChild(grid);

    return {
      carousel: carousel,
      container: container,
      grid: grid,
      items: visibleItems
    };
  }

  function needsGridRebuild(carousel, container, existing) {
    if (!existing) return false;
    if (carousel.getAttribute(INIT_ATTR) !== 'true') return false;
    if (container.querySelector('.jdgm-marquee-track')) return true;
    if (!container.querySelector('.jdgm-grid')) return true;
    if (carousel.classList.contains('jdgm-carousel--jdgm-marquee')) return true;
    return false;
  }

  function initCarousel(carousel) {
    if (!carousel) return null;

    var container = carousel.querySelector('.jdgm-carousel__item-container');
    if (!container) return null;

    var itemCount = getCarouselItems(container).length;
    if (!itemCount) return null;

    var existing = instances.find(function (inst) {
      return inst.carousel === carousel;
    });

    if (carousel.getAttribute(INIT_ATTR) === 'true' && existing && !needsGridRebuild(carousel, container, existing)) {
      return existing;
    }

    if (existing) {
      instances = instances.filter(function (inst) {
        return inst.carousel !== carousel;
      });
      destroyGrid(existing);
    }

    var instance = buildGrid(carousel);
    if (instance) {
      instances.push(instance);
      bindReviewCardInteractions(carousel);
    }
    return instance;
  }

  function initAll() {
    document.querySelectorAll('.jdgm-carousel--gallery-theme, .jdgm-carousel-wrapper .jdgm-carousel').forEach(function (carousel) {
      if (!carousel.querySelector('.jdgm-carousel__item-container')) return;
      initCarousel(carousel);
    });
  }

  function shouldReactToMutation(mutation) {
    if (mutation.type !== 'childList' || !mutation.addedNodes.length) return false;

    for (var i = 0; i < mutation.addedNodes.length; i++) {
      var node = mutation.addedNodes[i];
      if (node.nodeType !== 1) continue;

      if (node.classList) {
        if (node.classList.contains('jdgm-grid')) return false;
        if (node.classList.contains('jdgm-carousel-item')) return false;
      }

      if (node.closest && node.closest('.jdgm-grid')) return false;

      if (node.classList && node.classList.contains('jdgm-carousel')) return true;
      if (node.querySelector && node.querySelector('.jdgm-carousel--gallery-theme')) return true;
    }

    return false;
  }

  function scheduleInit() {
    if (observerTimer) clearTimeout(observerTimer);
    observerTimer = setTimeout(function () {
      observerTimer = null;
      initAll();
    }, OBSERVER_DEBOUNCE_MS);
  }

  function pageMayHaveCarousel() {
    return !!document.querySelector(
      '.jdgm-carousel--gallery-theme, .jdgm-carousel-wrapper .jdgm-carousel, .shopify-app-block'
    );
  }

  function connectCarouselObserver() {
    if (window.__jdgmGridObserverConnected) return;
    window.__jdgmGridObserverConnected = true;

    var root = document.querySelector('#MainContent') || document.body;
    if (!root) return;

    new MutationObserver(function (mutations) {
      var shouldInit = false;
      for (var i = 0; i < mutations.length; i++) {
        if (shouldReactToMutation(mutations[i])) {
          shouldInit = true;
          break;
        }
      }
      if (shouldInit) scheduleInit();
    }).observe(root, { childList: true, subtree: true });
  }

  window.JdgmCarouselGrid = {
    bootstrapped: true,
    initAll: initAll,
    refresh: scheduleInit
  };

  window.JdgmCarouselMarquee = window.JdgmCarouselGrid;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('judgeme:loaded', function () {
    scheduleInit();
    connectCarouselObserver();
  });

  if (pageMayHaveCarousel()) {
    setTimeout(scheduleInit, 800);
    connectCarouselObserver();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelector) return;
    var carousel = target.querySelector('.jdgm-carousel--gallery-theme');
    if (carousel) initCarousel(carousel);
  });
})();
